import moment from 'moment';
import { EvolutionForm } from 'src/app/shared/models/evolutionForm';
import { DATE_FORMAT, DATE_TIME_FORMAT } from './form-fields';

export function mapFormData(form: EvolutionForm): EvolutionForm {
    return {
        ...form,
        formSections: (form?.formSections ?? []).map(section => {
            const formData = typeof section.formData === 'string' ? JSON.parse(section.formData) : { ...section.formData };
            const properties = formData?.properties ?? {};
            Object.keys(properties).forEach(key => {
                const info = properties[key];
                if ((info?.format === 'date' || info?.format === 'date-time') && info.default) {
                    info.default = moment(info.default).format(info.format === 'date-time' ? DATE_TIME_FORMAT : DATE_FORMAT);
                }
            });
            return { ...section, formData };
        }),
    };
}
